import { accordion } from "./_accordion";
import { animation } from "./_animation";
import { countUp } from "./_countUp";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { form } from "./_form";
import { slide } from "./_slide";
import { modal } from "./_modal";
import { test } from "./_test";
import { tab } from "./_tab";
import { voiceScroll } from "./_voiceScroll";
import { topFunctions } from "./_topFunctions";
import { topVoice } from "./_topVoice";
import { topMv } from "./_topMv";
import { topMedia01 } from "./_topMedia01";
import { topTrouble } from "./_topTrouble";

accordion();
animation();
topFunctions();
topVoice();
topMv();
topMedia01();
topTrouble();
// countUp();
// common();
drawer();
form();
slide();
// modal(); //これがあるとtabが動かなくなる
// test();
tab();
voiceScroll();